import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-banks-global',
  templateUrl: './add-banks-global.component.html',
  styleUrls: ['./add-banks-global.component.scss']
})
export class AddBanksGlobalComponent implements OnInit {

  closeResult = '';

  constructor(
    private modalService: NgbModal,
  ) {}

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: 'mblbtm' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  openmdl(removePerson) {
    this.modalService.open(removePerson, {ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: 'mblbtm' });
  }
  
  ngOnInit(): void {
  }

}